import { CordovaService } from './../../services/cordova/cordova.service';
import {Component, Input} from '@angular/core';
import {SimpleWord} from '../../models/simple-word.model';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';

@Component({
  selector: 'app-word-record-btn',
  template: `
    <button type="button"
            *ngIf="cordova && word && word.wordVoice"
            class="record-btn"
            (click)="openRecord($event)"></button>
  `
})
export class WordRecordBtnComponent {
  @Input() word: SimpleWord;
  public get cordova(): any {
    return this.cordovaService.cordova;
  }

  constructor(
    public lm: LayoutMgrService,
    private cordovaService: CordovaService
  ) {
  }

  public openRecord(event: Event): void {
    console.log('app-word-record-btn onRecord() click', this.word);
    event.preventDefault();
    event.stopPropagation();

    this.lm.OpenPitchPopup(this.word);
  }
}
